module.exports = __webpack_public_path__ + "media/images/lb/309-33becbadd28b44a2fe61f5c171cf4864.svg";